/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ContractAsLP, ContractAsLPInterface } from "../ContractAsLP";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
      {
        internalType: "address",
        name: "_inbox",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "addLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addPauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "inbox",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isPauser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pausers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "_wdSeq",
        type: "uint64",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_toChain",
        type: "uint64",
      },
      {
        internalType: "uint64[]",
        name: "_fromChains",
        type: "uint64[]",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint32[]",
        name: "_ratios",
        type: "uint32[]",
      },
      {
        internalType: "uint32[]",
        name: "_slippages",
        type: "uint32[]",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ContractAsLPConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: ContractAsLPConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class ContractAsLP__factory extends ContractFactory {
  constructor(...args: ContractAsLPConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ContractAsLP";
  }

  deploy(
    _bridge: string,
    _inbox: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<ContractAsLP> {
    return super.deploy(_bridge, _inbox, overrides || {}) as Promise<ContractAsLP>;
  }
  getDeployTransaction(
    _bridge: string,
    _inbox: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_bridge, _inbox, overrides || {});
  }
  attach(address: string): ContractAsLP {
    return super.attach(address) as ContractAsLP;
  }
  connect(signer: Signer): ContractAsLP__factory {
    return super.connect(signer) as ContractAsLP__factory;
  }
  static readonly contractName: "ContractAsLP";
  public readonly contractName: "ContractAsLP";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ContractAsLPInterface {
    return new utils.Interface(_abi) as ContractAsLPInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ContractAsLP {
    return new Contract(address, _abi, signerOrProvider) as ContractAsLP;
  }
}
